
























































































































































import { Component, Vue } from "vue-property-decorator";
import LoginHeader from "@/components/header/ULoginHeader.vue";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";
import TurnstileWidget from "@/components/security/TurnstileWidget.vue";
import ContactApi from "@/services/ContactsApi";
import AuthModule from "@/store/auth";
import { Contacts } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

type ContactForm = Contacts & { turnstileToken?: string };

@Component({
  components: {
    Header,
    LoginHeader,
    Footer,
    TurnstileWidget,
  },
})
export default class Contact extends Vue {
  private isCompDialog = false;

  private isSubmitting = false;

  private turnstileToken = "";

  private turnstileSiteKey = process.env.VUE_APP_TURNSTILE_SITE_KEY || "";

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // 各フォームの初期値
  private form: ContactForm = { title: "", name: "", email: "", content: "" };

  // 送信が押された時
  private async submit() {
    if (this.isSubmitting || (this.turnstileSiteKey && !this.turnstileToken)) {
      return;
    }

    this.isSubmitting = true;
    try {
      await ContactApi.instance.sendContacts({
        ...this.form,
        turnstileToken: this.turnstileToken,
      });
      this.isCompDialog = true;
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    } finally {
      this.isSubmitting = false;
      this.turnstileToken = "";
      const widget = this.$refs.turnstileWidget as TurnstileWidget | undefined;
      if (widget) {
        widget.reset();
      }
    }
  }
}
